import React, { useEffect, useRef, useState } from "react";
import { Grid, Button, withStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import Inflow from "./Inflow";
import Outflow from "./Outflow";
import FamilyDetails from "../FamilyDetails";
import LoanDetailsPurpose from "./LoanDetailsPurpose";
import { annualIncomeValidate, isEmpty, validateFamilyDetails } from "./Validation";
import { formatAmount } from "utils/Utils";
import { purposeOfLoanListData } from "assets/properties/properties";
import { purposeOfLoanNewList } from "assets/properties/properties";
import { occupationDetailsActualLoanAmount } from "assets/properties/properties";
import { isValidValue } from "utils/Utils";
import { creditAssessmentLetterAmount } from "assets/properties/properties";
import { loanStatusNames } from "assets/properties/properties";
import { creditAssessmentFields } from "assets/properties/properties";
import { parseAndSetFlag } from "utils/Utils";
import { getEndpoint } from "utils/Utils";
import { creditApiAmountBtCase } from "assets/properties/properties";
import { APPLICATION_SUB_TYPE_PRE_PLEDGE } from "assets/properties/properties";
const styles = () => ({});
const FinancialAndFamilyDetails = ({
  classes,
  loanApplicationId,
  setNext,
  setBack,
  existingLoanData,
  mobileNum,
  editable,
  outletData,
  status,
  prePledgeLoan,
  prepledgeLoanMap,
  subStatus
}) => {  
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [actualLoanAmount, setActualLoanAmount] = useState("");
  const [toast, setToast] = useState(false); // keep only for NEXT validation
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [totalLoanAmountPerYear, setTotalLoanAmountPerYear] = useState(0);
  const [houseHoldExpenditure, setHouseHoldExpenditure] = useState("");
  const [otherEmi, setOtherEmi] = useState("");
  const [annualIncome, setAnnualIncome] = useState("");
  const [purposeOfLoan, setPurposeOfLoan] = useState("");
  const [meanPurposeOfLoan, setMeanPurposeOfLoan] = useState(purposeOfLoanNewList?.meanPurposeOfLoanList?.[0]);
  const [occupationProofDocName, setOccupationProofDocName] = useState("");
  const [occupationProofDocLink, setOccupationProofDocLink] = useState("");
  const [nextDisabled, setNextDisabled]=useState(false)
  const [creditScore, setCreditScore]=useState("")
  const [additionalIncomeList, setAdditionalIncomeList] = useState([
    {
      additionalSource: "",
      additionalIncome: "",
      address:"",
      attachment:"",
    },
  ]);
  const enableCreditAssesmentonBtCase = parseAndSetFlag(outletData?.enabledCreditAssesmentInBtPrePledge);
  const enableCreditAssesmentOnBtCases = enableCreditAssesmentonBtCase && subStatus === APPLICATION_SUB_TYPE_PRE_PLEDGE;
  const PurposeOfLoanList = outletData?.purposeOfLoanFlag ? JSON.parse(outletData?.purposeOfLoanFlag) : purposeOfLoanListData;
  const otherIncomeDetails = Number(outletData?.occupationDetailsActualAmount) || occupationDetailsActualLoanAmount;
  const enabledCreditApiAmountBtCase = Number(outletData?.enabledCreditApiAmountBtCase) || creditApiAmountBtCase;
  const otherIncomeDetailsValidationAmount =  enableCreditAssesmentOnBtCases ? enabledCreditApiAmountBtCase : otherIncomeDetails;
  const creditAssessmentLetterAmountFlag = Number(outletData?.creditAssessmentLetterAmountFlag) || creditAssessmentLetterAmount;
  const annualIncomeAmount = outletData?.annualIncomeFlag;
  const enableGetCreditScore= parseAndSetFlag(outletData?.enableCreditScoreApi)
  const creditAssesmentTenureBaseInterest = parseAndSetFlag(outletData?.creditAssesmentTenureBaseInterest)
  const showOtherIncome = (Number(actualLoanAmount) + Number(totalLoanAmountPerYear)) >= creditAssessmentLetterAmountFlag;
  const filterPurposeOfloan = (Number(actualLoanAmount) +  Number(totalLoanAmountPerYear)) <= otherIncomeDetailsValidationAmount;
  const getFamilyDetailsData = additionalIncomeList?.filter((item)=> item.additionalSource?.toLowerCase() === creditAssessmentFields?.showFamilyDetailsSource)
  const salePropertyData = additionalIncomeList?.filter((item)=> item.additionalSource?.toLowerCase() === creditAssessmentFields?.showAddressSource)
  const checkCreditScore = (Number(actualLoanAmount) +  Number(totalLoanAmountPerYear)) >= otherIncomeDetailsValidationAmount;
  const [creditScoreApiCall, setCreditScoreApiCall] = useState(false);
  const [previouseLoanInterest, setPreviouseLoanInterest] = useState(0);
  const [cibilReportUrl, setCibilReportUrl]=useState("");
  const enableCreditAddtionalAttachement = parseAndSetFlag(outletData?.enableAttachementOnCreditAdditionDetails);
  const skipAnnualIncomeValidations = parseAndSetFlag(outletData?.skipAnnualIncomeValidations);
  const houseHoldExpenditureBlurValidationValue = creditAssesmentTenureBaseInterest ? 100000 : 250000
  const [interest, setInterest]=useState(0);
  const getEmptyMember = () => ({
    name: "",
    relationship: "",
    mobileNumber: "",
    income: "",
    id: null,
    isLocked: false,
    errors: {
      name: false,
      relationship: false,
      mobileNumber: false,
      income: false,
    },
  });
  const [familyList, setFamilyList] = useState([
    getEmptyMember(),
    getEmptyMember(),
  ]);
  const hasCalledApi = useRef(false);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const searchProfile = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.SEARCH_PROFILE + mobileNum?.trim(),
      authToken: authToken,
    });
    setCallInProgress(false);
    setCreditScoreApiCall(true);
     if (result?.data?.length === 1) {
      setAnnualIncome(result?.data?.[0]?.applicantAnnualIncome);
      await getTotalLoanAmount(result?.data?.[0]?.customerId);
    }else if (result?.data?.length > 1) {
      toastUpdate("Error","Multiple customer id Link with this");
    }
  };
  const getTotalLoanAmount = async (custId) => {
    setCallInProgress(true);
    let loanAccountNumbers;
    if (prepledgeLoanMap && Object.keys(prepledgeLoanMap).length > 0) {
      loanAccountNumbers = Object.keys(prepledgeLoanMap).join(",");
    } else if (prePledgeLoan) {
      loanAccountNumbers = prePledgeLoan;
    }
    const params = {
      customerId: custId,
      ...(loanAccountNumbers && { loanAccountNumbers }),
    };

    const result = await apiHandler({
      url: getEndpoint(endpoint.GET_LOAN_AMOUNT_BY_CUST_ID, params),
      authToken,
    });

    setCallInProgress(false);
    if (!result?.data?.error_code) {

      setTotalLoanAmountPerYear(result?.data?.totalOutstandingPrincipal);
    }
  };

  const getCreditAssementDetails = async (actualLoanAmounts) => {
    setCallInProgress(true)
    const result = await apiHandler({
      url: endpoint.CREDIT_ASSESSMENT_DATA_FIND + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false)
    if(Number(result?.data?.existingMonthlyEmiObligation) > 0 || Number(result?.data?.creditScore) > 0){
      setOtherEmi(result?.data?.existingMonthlyEmiObligation); 
      setCreditScore(result?.data?.creditScore);
      setCibilReportUrl(result?.data?.cibilReportUrl);
    }else{
      if(actualLoanAmounts >= otherIncomeDetailsValidationAmount ){
        setCreditScoreApiCall(true)
      }
    }
    if (!!result?.data?.purposeOfLoan &&
        !!result?.data?.purposeOfLoanSubCategory) {
      const data = result?.data;
      setTotalLoanAmountPerYear(data?.totalOutstandingAmount);
      if (
        Array.isArray(data?.additionalDetails) &&
        data.additionalDetails.length
      ) {
        setAdditionalIncomeList(
          data.additionalDetails.map((item) => ({
            additionalSource: item.name,
            additionalIncome: item.amount,
            attachment: item.attachment,
            address: item.address,
          }))
        );
      } else {
        setAdditionalIncomeList([
          {
            additionalSource: "",
            additionalIncome: "",
            address: "",
            attachment: ""
          },
        ]);
      }
      setAnnualIncome(data?.annualIncome);
      setHouseHoldExpenditure(data?.householdExpenses);
      setMeanPurposeOfLoan(data?.purposeOfLoan);
      setPurposeOfLoan(data?.purposeOfLoanSubCategory);
      setInterest(Number(data?.prevLoanInterest) + Number(data?.currentLoanInterest));
      if(data?.purposeOfLoan !== purposeOfLoanNewList?.consumption){
        await getDocumentList();
      }
    } else {
      await searchProfile();
    }
  };

  const getCreditScore = async () => {
    setCallInProgress(true)
    const res = await apiHandler({
      url: endpoint.GET_CREDIT_SCORE_AND_EMI + loanApplicationId,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false)
    if (res?.data?.error_code === 500 || res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      setNextDisabled(true)
    } else {
      setNextDisabled(false)
      setOtherEmi(res?.data?.existingMonthlyEmiObligation);
      setCreditScore(res?.data?.creditScore);
      setCibilReportUrl(res?.data?.cibilReportUrl);
    }
  };

  const getDocumentList = async () => {
    setCallInProgress(true)
    const res = await apiHandler({
      url: endpoint.FIND_DOUMENTS + loanApplicationId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false)
    if (res?.data?.error_code === 500 || res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      setOccupationProofDocLink(res?.data?.occupationProofDocUrl);
      setOccupationProofDocName(res?.data?.occupationProofDocName);
    }
  };

  const getExposureAmount = async (proposeAmt) => {
      setCallInProgress(true);
      const result = await apiHandler({
        url: endpoint.EXPOSURE_AMOUNT_GET,
        method: "POST",
        authToken: authToken,
        data: {
          mobileNumber: mobileNum,
          currentLoanOrnamentValue:0,
          schemeCode:"",
          bulletScheme: false,
          currentLoanAmount: proposeAmt || 0,
        },
      });
      setCallInProgress(false);
      if(!result?.data?.error_code){
        const getLoanArray = prePledgeLoan ? result?.data?.loans?.filter(item => item.loanAccountNumber !== prePledgeLoan) : result?.data?.loans;
        const exposureDetailsTotalAmountInterest = getLoanArray?.reduce( (total, loan) => total + Number(loan?.futureInterest || 0) , 0)
        setPreviouseLoanInterest(exposureDetailsTotalAmountInterest)
      }
  }

  const getOrnamentData = async () => {
    const apiEndPoint = enableCreditAssesmentOnBtCases ?  endpoint.PawanTicket_Detials_get  : endpoint.ORNAMENT_GETDATA;
    const result = await apiHandler({
      url: apiEndPoint + loanApplicationId,
      authToken: authToken,
    });
    if (!result?.data?.error_code) {
      setActualLoanAmount(result?.data?.actualLoanAmount);
      if(isValidValue(result?.data?.revisedLoanAmt) && Number(result?.data?.revisedLoanAmt) > 0){
        setActualLoanAmount(result?.data?.revisedLoanAmt)
      }
      await getCreditAssementDetails(result?.data?.actualLoanAmount);
      if(creditAssesmentTenureBaseInterest && editable){
         await getExposureAmount(result?.data?.actualLoanAmount);
      }
    }
  };
  useEffect(()=>{
    if(checkCreditScore && enableGetCreditScore && !creditScore && editable && creditScoreApiCall && !hasCalledApi.current){
        getCreditScore();
       hasCalledApi.current = true;
      }
  },[checkCreditScore, enableGetCreditScore, creditScore, creditScoreApiCall])
  useEffect(() => {
    getOrnamentData();
  }, []);
  const interestOnPropsedLoan = Number(previouseLoanInterest) + (Number(actualLoanAmount) * 0.21);
  const flatInterest = (Number(totalLoanAmountPerYear) + Number(actualLoanAmount)) * 0.3
  const interestPayment = creditAssesmentTenureBaseInterest ? interestOnPropsedLoan : flatInterest;
  const finalInterest = editable ? interestPayment : interest;
  // for just adde interest propsed + existing loan amount
  const totalOutFlowOnlyInterest = Math.round(interestOnPropsedLoan) + Number(houseHoldExpenditure || 0) +  Math.round(Number(otherEmi || 0))
  // for all amount added in outlfow
  const totalOutFlowAllAmount =  Number(actualLoanAmount || 0) + Number(totalLoanAmountPerYear || 0) + Math.round(flatInterest) + Number(houseHoldExpenditure || 0) + Math.round(Number(otherEmi || 0));
 
  const totalOutflowAmt = skipAnnualIncomeValidations ? totalOutFlowOnlyInterest : totalOutFlowAllAmount;
  
  const totalInFlowIncome =
    Number(annualIncome || 0) +
    additionalIncomeList.reduce(
      (sum, item) =>
        sum + Number(item.additionalIncome || 0),
      0
    ) 
  const handleBlurAnnualIncome = (e) => {
    const value = Number(e);
    if(value < Number(annualIncomeAmount) && !showOtherIncome){
      toastUpdate("Error", `Cash Inflow is not sufficient`, true);
      return;
    }
    const validation = annualIncomeValidate(totalOutflowAmt, value);
    if (!showOtherIncome || validation?.isValid) {
      setAnnualIncome(value);
    } else {
      toastUpdate( "Error", "Cash Inflow is not sufficient", true );
    }
  };

  const isValidated = () => {
    const validateAnnualIncome = annualIncomeValidate(
      totalOutflowAmt,
      annualIncome
    );
    if(!meanPurposeOfLoan){
      toastUpdate("Error", `Please select the purpose of loan`, true);
      return false;
    }
    if(!purposeOfLoan){
      toastUpdate("Error", `Please select the purpose of loan type`, true);
      return false;
    }
       if(Number(annualIncome) < Number(annualIncomeAmount) && !showOtherIncome){
      toastUpdate("Error", `Cash Inflow is not sufficient`, true);
      return;
    }
    if (showOtherIncome && !validateAnnualIncome?.isValid) {
      toastUpdate(
        "Error",
        "Cash Inflow is not sufficent",
        true
      );
      return false;
    }
    if (showOtherIncome && totalInFlowIncome < totalOutflowAmt * 1.2) {
      toastUpdate("Error", "Annual Inflow Not sufficient", true);
      return false;
    }
    if(showOtherIncome && (purposeOfLoan === purposeOfLoanNewList?.agriculture ||
      purposeOfLoan === purposeOfLoanNewList?.business) && !isValidValue(occupationProofDocLink)){
      toastUpdate("Error","Please upload the occupation proof document or change the purpose of the loan",true);
      return false;
    }
    if (showOtherIncome && salePropertyData?.length > 0 && !salePropertyData?.[0]?.address) {
      toastUpdate("Error", "Sale Property Address cannot be empty", true);
      return false;
    }
    if (showOtherIncome) {
    
      const hasIncompleteRow = additionalIncomeList?.some(
        (item) =>
          (item?.additionalSource && !item?.additionalIncome) ||
          (!item?.additionalSource && item?.additionalIncome)
      );
    
      if (hasIncompleteRow) {
        toastUpdate(
          "Error",
          "Please complete all Additional Income details",
          true
        );
        return false;
      }
    }
    if (getFamilyDetailsData?.length > 0) {
      const totalFamilyIncome = familyList.reduce(
        (sum, item) => sum + Number(item.income || 0),
        0
      );
      if (!validateFamilyDetails(familyList, toastUpdate, editable)) {
        return false;
      }
      if (totalFamilyIncome !== Number(getFamilyDetailsData?.[0]?.additionalIncome)) {
        toastUpdate(
          "Error",
          "Total family savings/investment income must be equal to the family income/saving amount",
          true
        );
        return false;
      }
    }    
    if(!isValidValue(houseHoldExpenditure) && showOtherIncome){
      toastUpdate("Error", "Please fill the Househould Expenditure", true);
        return false;
    }
    if(isValidValue(houseHoldExpenditure) && showOtherIncome  && Number(houseHoldExpenditure) < Number(houseHoldExpenditureBlurValidationValue)){
      toastUpdate("Error", `House hold expenditure should not less than ${houseHoldExpenditureBlurValidationValue}`, true);
        return false;
    }
    return true;
  };
  const documentUpdateLink = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.ADMIN_DOCUMENT_UPDATELINKS,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
        occupationProofDocName: occupationProofDocName,
        occupationProofDocUrl: occupationProofDocLink,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true)
    } else {
      setNext();
    }
  };

  const handleAddData = async () => {
    setCallInProgress(true);

    const payload = {
      loanApplicationId,
      householdExpenses: houseHoldExpenditure,
      annualIncome,
      purposeOfLoan: meanPurposeOfLoan,
      purposeOfLoanSubCategory: purposeOfLoan,
      additionalDetails: additionalIncomeList
        .filter(
          (item) =>
            item.additionalSource &&
            Number(item.additionalIncome) > 0
        )
        .map((item) => ({
          name: item.additionalSource,
          amount: Number(item.additionalIncome),
          address: item?.address,
          attachment: item?.attachment
        })),
      totalOutstandingAmount:totalLoanAmountPerYear,
      prevLoanInterest: creditAssesmentTenureBaseInterest ? Number(previouseLoanInterest) : Number(totalLoanAmountPerYear) * 0.3,
      currentLoanInterest: creditAssesmentTenureBaseInterest ? (Number(actualLoanAmount) * 0.21) : (Number(actualLoanAmount) * 0.3),
    };

    const response = await apiHandler({
      url: endpoint.CREDIT_ASSESSMENT_DATA_CREATE,
      authToken,
      method: "POST",
      data: payload,
    });

    setCallInProgress(false);

    if (response?.data?.error_code) {
      toastUpdate(
        "Error",
        response?.data?.user_description,
        true
      );
    } else {
      if (showOtherIncome) {
        await documentUpdateLink();
      } else {
        setNext();
      }
    }
  };

  const handleNext = async () => {
    if(status === loanStatusNames?.inProcess || status === loanStatusNames?.aadhaar || status === loanStatusNames?.selfie){
    const valid = isValidated();
    if (!valid) return;
    await handleAddData();
    }else{
      setNext();
    }
  };

    const houseHoldExpenditureBlur = (e) =>{
      if(Number(e) < Number(houseHoldExpenditureBlurValidationValue)){
        toastUpdate("Error", `House hold expenditure should not be less than ${houseHoldExpenditureBlurValidationValue}`, true)
      }
    }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <SubHeader label="Credit Assessment" onlyLabel />
      </Grid>
      <LoanDetailsPurpose
        showOtherIncome
        purposeOfLoan={purposeOfLoan}
        outletData={outletData}
        setPurposeOfLoan={setPurposeOfLoan}
        meanPurposeOfLoan={meanPurposeOfLoan}
        setMeanPurposeOfLoan={setMeanPurposeOfLoan}
        occupationProofDocLink={occupationProofDocLink}
        setOccupationProofDocLink={setOccupationProofDocLink}
        occupationProofDocName={occupationProofDocName}
        setOccupationProofDocName={setOccupationProofDocName}
        PurposeOfLoanList={PurposeOfLoanList}
        editable={editable}
        filterPurposeOfloan={filterPurposeOfloan}
      />
      {showOtherIncome &&  <Outflow
          totalLoanAmountPerYear={totalLoanAmountPerYear}
          actualLoanAmount={actualLoanAmount}
          editable={editable}
          setOtherEmi={setOtherEmi}
          otherEmi={otherEmi}
          houseHoldExpenditure={houseHoldExpenditure}
          setHouseHoldExpenditure={setHouseHoldExpenditure}
          totalOutflowAmt={totalOutflowAmt}
          creditScore={creditScore}
          checkCreditScore={checkCreditScore && enableGetCreditScore}
          houseHoldExpenditureBlur={houseHoldExpenditureBlur}
          interestPayment={finalInterest}
          cibilReportUrl={cibilReportUrl}
          skipAnnualIncomeValidations={skipAnnualIncomeValidations}
        />
      }
      <Inflow
        editable={editable}
        annualIncome={annualIncome}
        setAnnualIncome={setAnnualIncome}
        handleBlurAnnualIncome={handleBlurAnnualIncome}
        totalInFlowIncome={totalInFlowIncome}
        showOtherIncome={showOtherIncome}
        setAdditionalIncomeList={setAdditionalIncomeList}
        additionalIncomeList={additionalIncomeList}
        toastUpdate={toastUpdate}
        familyList={familyList}
        enableCreditAddtionalAttachement={enableCreditAddtionalAttachement}
        setCallInProgress={setCallInProgress}
        skipAnnualIncomeValidations={skipAnnualIncomeValidations}
      />
      {getFamilyDetailsData?.length > 0 &&
        <FamilyDetails
          mobileNum={mobileNum}
          loanApplicationId={loanApplicationId}
          existingLoanData={existingLoanData}
          editable={editable}
          getEmptyMember={getEmptyMember}
          familyList={familyList}
          setFamilyList={setFamilyList}
          getFamilyDetailsData={getFamilyDetailsData}
        />
      }
      <Grid
        item
        xs={12}
        style={{
          textAlign: "end",
          marginTop: 10,
        }}
      >
        <Button
          size="small"
          className={classes.nextButton1}
          onClick={() => setBack()}
        >
          Back
        </Button>

        <Button
          size="small"
          className={classes.nextButton}
          onClick={() => handleNext()}
          disabled={callInProgress || nextDisabled}
        >
          Next
        </Button>
      </Grid>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}

      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </Grid>
  );
};

export default withStyles(styles)(FinancialAndFamilyDetails);
